// extracted by mini-css-extract-plugin
export default {"pm-info-btn":"PaperMatrix_pm-info-btn__GLSKO","selected-options":"PaperMatrix_selected-options__Qy9eb","table":"PaperMatrix_table__wEis3"};